<template>
  <AuthLayout>
    <div v-if="finishUpdate" class="mobile-view">
      Thank you for registering on the Lavita platform! The sign-up has been
      completed successfully. <br /><br />
      Please note that the Lavita platform website is optimized for use on
      desktop browsers. Please login with your new Lavita account from a desktop
      browser to explore our platform
    </div>
    <div v-else class="nftmax-wc__form">
      <div class="nftmax-wc__form-inner">
        <div class="nftmax-wc__heading">
          <h3
            class="nftmax-wc__form-title nftmax-wc__form-title__three"
            style="
              background-image: url('../../assets/img/heading-vector-3.png');
            "
          >
            Sign Up Verification
          </h3>
        </div>
        <!-- Sign in Form -->
        <form class="nftmax-wc__form-main" action="#" method="post">
          <div class="form-group">
            <label class="nftmax-wc__form-label">Verification Code</label>
            <div class="form-group__input">
              <el-input v-model="code" placeholder=""></el-input>
            </div>
            Enter the verification code that was sent to your email address
          </div>
          <div class="form-group">
            <div class="nftmax-wc__button">
              <el-button
                class="ntfmax-wc__btn"
                type="submit"
                :loading="isVerifying"
                @click="finishUpdateHandler"
              >
                Verify
              </el-button>
            </div>
          </div>
          <div class="form-group">
            <div class="nftmax-wc__bottom">
              <p class="nftmax-wc__text">
                Don't received a code?
                <span v-if="countdown > 0" class="countdown-text">
                  Resend in {{ countdown }}s
                </span>
                <a
                  v-else
                  href="#"
                  class="resend-link"
                  :class="{ loading: isResending }"
                  @click.prevent="resendCode"
                >
                  {{ isResending ? "Sending..." : "Please resend" }}
                </a>
              </p>
            </div>
          </div>
        </form>
        <!-- End Sign in Form -->
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/Auth/AuthLayout";
import api from "../../http/api";

export default {
  components: { AuthLayout },
  data() {
    return {
      code: "",
      finishUpdate: false,
      countdown: 60, // 倒计时60秒
      countdownTimer: null,
      isResending: false,
      isVerifying: false,
    };
  },
  computed: {
    isMobile() {
      const userAgent = navigator.userAgent;
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
      return isMobile;
    },
  },
  mounted() {
    this.$vToastify.success(
      "Verification code has been sent to the email address"
    );
    this.startCountdown();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    async finishUpdateHandler() {
      try {
        if (this.code !== "") {
          this.isVerifying = true;
          await api.signUpVerify({
            username: this.$route.params.userName,
            code: this.code,
          });
          if (this.isMobile) {
            this.finishUpdate = true;
          } else {
            const res = await api.logIn({
              username: this.$route.params.userName,
              password: this.$route.params.password.split(""),
              token: "",
            });
            this.$store.commit("saveUserInfo", res.data.data);
            this.$router.push("/my-contributions");
          }
        } else {
          this.$vToastify.error("Please fill all fields");
        }
      } catch (error) {
        console.log(error);
        this.$vToastify.error("Verification failed, please try again");
      } finally {
        this.isVerifying = false;
      }
    },
    async resendCode() {
      try {
        this.isResending = true;
        await api.sendCodeToEmail({
          email: this.$route.params.userName,
        });
        this.$vToastify.success(
          "Verification code has been resent to your email"
        );
        this.startCountdown();
      } catch (error) {
        console.log(error);
        this.$vToastify.error(
          "Failed to resend verification code, please try again"
        );
      } finally {
        this.isResending = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.mobile-view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 25px;
  line-height: 35px;
  margin: 0 30px;
  text-align: center;
}

.verification-info {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

.countdown-text {
  color: inherit;
  font-size: inherit;
}

.resend-link {
  color: #409eff;
  text-decoration: none;
  font-size: inherit;
}

.resend-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.resend-link.loading {
  color: #999;
  cursor: not-allowed;
}

.resend-link.loading:hover {
  text-decoration: none;
}
</style>
